import React from 'react';
import { useParams } from 'react-router-dom';
import CreateIndigentForm from '../modules/Indigent/CreateIndigentForm';

const EditIndigentPage: React.FC = () => {
    const { requestId } = useParams<{ requestId: string }>();

    if (!requestId) {
        return <div>Invalid request ID</div>;
    }

    return <CreateIndigentForm mode='edit' requestId={requestId} />;
};

export default EditIndigentPage;
